import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { usePaymentsModalButton, PaymentRequestModal } from '@frontend/payments-collection-flow';
import { REQUEST_ORIGINS } from '@frontend/person-invoice-create';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { usePaymentAlerts } from '../../../hooks/navigation-alert/use-payment-alerts';
import { PaymentsNavAlerts } from '../../../utils/helpers';

const styles = {
  createButton: css`
    width: auto;
    padding-left: ${theme.spacing(1)};
  `,
  plusIcon: css`
    margin-right: ${theme.spacing(1)};
  `,
};

export type NewInvoiceActionProps = {
  locationIds: string[];
  trackingId?: string;
};

export const NewInvoiceAction = ({ trackingId, locationIds }: NewInvoiceActionProps) => {
  const { t } = useTranslation('payments');
  const { showPaymentAlert } = usePaymentAlerts();
  const { paymentRequestModalProps, triggerProps } = usePaymentsModalButton({ locationIds });
  const isMobile = useMatchMedia({ maxWidth: breakpoints.small.max });

  return (
    <>
      <Button
        trackingId={trackingId}
        iconName='plus'
        variant='primary'
        size='large'
        css={styles.createButton}
        {...triggerProps}
      >
        {isMobile ? t('New') : t('Request Payment')}
      </Button>

      <PaymentRequestModal
        {...paymentRequestModalProps}
        origin={REQUEST_ORIGINS.REQUESTS}
        onInvoiceCreated={() => {
          showPaymentAlert(PaymentsNavAlerts.CreatePaymentRequest);
        }}
      />
    </>
  );
};
